<template>
	<!--TODO: refactor uploader section -->
	<section class="b360-grid-row preference-center-section">
		<title-description
			class="b360-col-xs-12 b360-col-sm-12 b360-col-md-4 b360-col-lg-4 form-title-description"
			:title="title"
			:description="description"
		></title-description>
		<div class="b360-col-xs-12 b360-col-sm-12 b360-col-md-8">
			<section class="top-btn-wrapper">
				<span class="b360-filter-wrapper">
					<font-awesome-icon :icon="['fal', 'search']" class="filter-icon" />
					<input
						class="b360-form-input"
						type="search"
						aria-label="Partner Filter enter partner name"
						name="Brand360Filter"
						id="partner-filter-input"
						placeholder="Filter Partners"
					/>
				</span>
				<button
					type="button"
					id="create-new-partner"
					class="b360-btn--primary create-new-btn"
					@click="createPartnerClick"
				>
					<font-awesome-icon
						class="icon-btn-left"
						:icon="['far', 'plus-circle']"
					/>Create New
				</button>
				<PartnerModalWrapper
					v-if="showModal"
					:show="showModal"
					@close="showModal = false"
					modalTitle="Create Partner"
					actionBtnName="Save"
					:deleteBtn="false"
					@modal-action="managePartnerAction"
				>
					<PartnersModal slot="modalContent" />
				</PartnerModalWrapper>
			</section>

			<section v-for="(item, index) in brandingPartners" :key="index">
				<PartnersFilterItem :brandingPartners="item" />
			</section>
		</div>
	</section>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import profileApiClient from '@/services/profile/profile-service';
import TitleDescription from '@/components/global/TitleDescription.vue';
import PartnersFilterItem from '@/components/preference-center/PartnersFilterItem.vue';
import PartnersModal from '@/components/preference-center/PartnersModal.vue';
import PartnerModalWrapper from '@/components/preference-center/PartnerModalWrapper.vue';

export default {
	name: 'PreferenceCenterPartners',
	components: {
		TitleDescription,
		PartnersFilterItem,
		PartnerModalWrapper,
		PartnersModal,
	},
	data() {
		return {
			title: 'Partners',
			description:
				'Add partners so you can choose to include them on marketing materials.',
			partnerImage: String,
			partnerName: String,
			partnerTitle: String,
			showModal: false,
		};
	},
	computed: {
		...mapState({
			brandingOptions: (state) => state.workspaceBranding.brandingOptions,
			brandingPartners: (state) =>
				state.partners.brandingPartners.filter(
					(el) => el.activeIndicator === true,
				),
			partner: (state) => state.partners.newPartner,
			contactId: (state) => state.profile.contactId,
		}),
	},
	methods: {
		...mapActions(['setPartners', 'createPartner', 'savePartner']),

		createPartnerClick() {
			this.createPartner();
			this.showModal = true;
		},

		managePartnerAction(actionType) {
			if (actionType !== 'delete') {
				profileApiClient.savePartners(this.contactId, this.partner);
				this.savePartner(this.partner);
			}
		},
	},
	created() {
		// const partnerApiResponse = partnersApiClient().getUserProfile({ userId: 8 });
		// this.setPartners(partnerApiResponse);
	},
};
</script>

<style scoped lang="scss">
.top-btn-wrapper {
	display: flex;
	flex-wrap: wrap;
	@include rem(margin-bottom, 30px);

	@include larger-than-mobile {
		flex-wrap: unset;
	}
}

.b360-form-input[type='search'] {
	margin: 0;
	padding-left: 46px;
}

.b360-filter-wrapper {
	position: relative;
	display: flex;
	flex-basis: 100%;
	@include rem(margin-bottom, 15px);

	@include larger-than-mobile {
		@include rem(margin-right, 15px);
		margin-bottom: unset;
	}
}

.filter-icon {
	position: absolute;
	top: 13px;
	left: 13px;
	color: $brand-blue;
}

.create-new-btn {
	min-width: 132px;

	@include mobile {
		width: 100%;
	}
}

.icon-btn-left {
	@include rem(margin-right, 12px);
}
</style>
